import React from 'react';
import Button from '../muiComponents/Button';
import useTranslate from '../customHooks/useTranslate';

interface ChangeViewButtonBarProps {
    changeVisibleView: (view: string) => void;
    buttons: {
        icon: string;
        label: string;
        view: string;
    }[];
}

const ChangeViewButtonBar = (props: ChangeViewButtonBarProps) => {
    const { changeVisibleView, buttons } = props;
    const translate = useTranslate();

    return (
        <div>
            {buttons.map(button => (
                <Button
                    key={button.view}
                    onClick={() => changeVisibleView(button.view)}
                    startIcon={button.icon}
                    color='secondary'
                >
                    {translate(button.label)}
                </Button>
            ))}
        </div>
    );
};

export default ChangeViewButtonBar;
